// Personal golfer-list storage (localStorage).
// Shape: { [listName]: string[] }
const KEY = "pbo-saved-lists-v1";

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
};

const write = (data) => {
  localStorage.setItem(KEY, JSON.stringify(data));
};

export const getLists = () => read();

export const getListNames = () => Object.keys(read()).sort((a, b) => a.localeCompare(b));

export const getList = (name) => read()[name] || null;

export const saveList = (name, golfers) => {
  const data = read();
  const cleaned = (golfers || [])
    .map((s) => String(s || "").trim())
    .filter(Boolean);
  // Dedupe (case-insensitive) preserving original casing.
  const seen = new Set();
  const out = [];
  for (const g of cleaned) {
    const k = g.toLowerCase();
    if (seen.has(k)) continue;
    seen.add(k);
    out.push(g);
  }
  data[name.trim()] = out;
  write(data);
};

export const renameList = (oldName, newName) => {
  const data = read();
  if (!data[oldName]) return false;
  if (oldName === newName) return true;
  if (data[newName]) return false; // collision
  data[newName] = data[oldName];
  delete data[oldName];
  write(data);
  return true;
};

export const deleteList = (name) => {
  const data = read();
  delete data[name];
  write(data);
};

export const exportListsJson = () => JSON.stringify(read(), null, 2);

export const importListsJson = (json, { merge = true } = {}) => {
  let incoming;
  try {
    incoming = JSON.parse(json);
  } catch {
    throw new Error("Not valid JSON");
  }
  if (!incoming || typeof incoming !== "object" || Array.isArray(incoming)) {
    throw new Error("Expected an object of { listName: [golfer, …] }");
  }
  // Validate shape
  for (const [k, v] of Object.entries(incoming)) {
    if (!Array.isArray(v) || v.some((g) => typeof g !== "string")) {
      throw new Error(`List "${k}" must be an array of strings`);
    }
  }
  const current = merge ? read() : {};
  for (const [name, arr] of Object.entries(incoming)) {
    const cleaned = arr.map((s) => s.trim()).filter(Boolean);
    const seen = new Set();
    const out = [];
    for (const g of cleaned) {
      const k = g.toLowerCase();
      if (seen.has(k)) continue;
      seen.add(k);
      out.push(g);
    }
    current[name.trim()] = out;
  }
  write(current);
};
